import MpxIconAccount from '../../../../icon/account.svg';
import MpxIconAccountMapping from '../../../../icon/account-mapping.svg';
import MpxIconAdd from '../../../../icon/add.svg';
import MpxIconAddOutline from '../../../../icon/add-outline.svg';
import MpxIconAddOns from '../../../../icon/add-ons.svg';
import MpxIconApplyAll from '../../../../icon/apply-all.svg';
import MpxIconApprovalRules from '../../../../icon/approval-rules.svg';
import MpxIconArrowLeft from '../../../../icon/arrow-left.svg';
import MpxIconArrowRight from '../../../../icon/arrow-right.svg';
import MpxIconAssets from '../../../../icon/assets.svg';
import MpxIconBilling from '../../../../icon/billing.svg';
import MpxIconBriefcase from '../../../../icon/briefcase.svg';
import MpxIconBroadcast from '../../../../icon/broadcast.svg';
import MpxIconBuy from '../../../../icon/buy.svg';
import MpxIconCalculator from '../../../../icon/calculator.svg';
import MpxIconCalendar from '../../../../icon/calendar.svg';
import MpxIconCalendarSmall from '../../../../icon/calendar-small.svg';
import MpxIconCamera from '../../../../icon/camera.svg';
import MpxIconCameraSmall from '../../../../icon/camera-small.svg';
import MpxIconCaretDown from '../../../../icon/caret-down.svg';
import MpxIconCaretRight from '../../../../icon/caret-right.svg';
import MpxIconCashAndBank from '../../../../icon/cash-and-bank.svg';
import MpxIconCertificate from '../../../../icon/certificate.svg';
import MpxIconChannel from '../../../../icon/channel.svg';
import MpxIconCheck from '../../../../icon/check.svg';
import MpxIconChartOfAccount from '../../../../icon/chart-of-account.svg';
import MpxIconChevronDown from '../../../../icon/chevron-down.svg';
import MpxIconChevronForward from '../../../../icon/chevron-forward.svg';
import MpxIconChevronLeft from '../../../../icon/chevron-left.svg';
import MpxIconChevronLeftSmall from '../../../../icon/chevron-left-small.svg';
import MpxIconChevronPrevious from '../../../../icon/chevron-previous.svg';
import MpxIconChevronRight from '../../../../icon/chevron-right.svg';
import MpxIconChevronRightSmall from '../../../../icon/chevron-right-small.svg';
import MpxIconChevronUp from '../../../../icon/chevron-up.svg';
import MpxIconClose from '../../../../icon/close.svg';
import MpxIconCloseSmall from '../../../../icon/close-small.svg';
import MpxIconCollapse from '../../../../icon/collapse.svg';
import MpxIconColumnSettings from '../../../../icon/column-settings.svg';
import MpxIconCompany from '../../../../icon/company.svg';
import MpxIconContact from '../../../../icon/contact.svg';
import MpxIconDashboard from '../../../../icon/dashboard.svg';
import MpxIconDental from '../../../../icon/dental.svg';
import MpxIconDownload from '../../../../icon/download.svg';
import MpxIconEdit from '../../../../icon/edit.svg';
import MpxIconEditSmall from '../../../../icon/edit-small.svg';
import MpxIconEducation from '../../../../icon/education.svg';
import MpxIconEmpty from '../../../../icon/empty.svg';
import MpxIconEnvelope from '../../../../icon/envelope.svg';
import MpxIconError from '../../../../icon/error.svg';
import MpxIconExpand from '../../../../icon/expand.svg';
import MpxIconExpenses from '../../../../icon/expenses.svg';
import MpxIconExternalLink from '../../../../icon/external-link.svg';
import MpxIconFamily from '../../../../icon/family.svg';
import MpxIconFileBlank from '../../../../icon/file-blank.svg';
import MpxIconFileCopy from '../../../../icon/file-copy.svg';
import MpxIconFileDoc from '../../../../icon/file-doc.svg';
import MpxIconFileImg from '../../../../icon/file-img.svg';
import MpxIconFilePdf from '../../../../icon/file-pdf.svg';
import MpxIconFileText from '../../../../icon/file-text.svg';
import MpxIconFileZip from '../../../../icon/file-zip.svg';
import MpxIconFilter from '../../../../icon/filter.svg';
import MpxIconFinance from '../../../../icon/finance.svg';
import MpxIconFlag from '../../../../icon/flag.svg';
import MpxIconHelp from '../../../../icon/help.svg';
import MpxIconHelpCenter from '../../../../icon/help-center.svg';
import MpxIconHide from '../../../../icon/hide.svg';
import MpxIconHideSmall from '../../../../icon/hide-small.svg';
import MpxIconHistory from '../../../../icon/history.svg';
import MpxIconHome from '../../../../icon/home.svg';
import MpxIconInbox from '../../../../icon/inbox.svg';
import MpxIconIndividualGoal from '../../../../icon/individual-goal.svg';
import MpxIconInPatient from '../../../../icon/in-patient.svg';
import MpxIconIndicator from '../../../../icon/indicator.svg';
import MpxIconInfo from '../../../../icon/info.svg';
import MpxIconInfoSmall from '../../../../icon/info-small.svg';
import MpxIconKebab from '../../../../icon/kebab.svg';
import MpxIconKebabSmall from '../../../../icon/kebab-small.svg';
import MpxIconKeyDuotone from '../../../../icon/key-duotone.svg';
import MpxIconKeyFill from '../../../../icon/key-fill.svg';
import MpxIconKeyOutline from '../../../../icon/key-outline.svg';
import MpxIconLoader from '../../../../icon/loader.svg';
import MpxIconLoan from '../../../../icon/loan.svg';
import MpxIconLogoAxis from '../../../../icon/logo-axis.svg';
import MpxIconLogoChat from '../../../../icon/logo-chat.svg';
import MpxIconLogoChatColor from '../../../../icon/logo-chat-color.svg';
import MpxIconLogoFlex from '../../../../icon/logo-flex.svg';
import MpxIconLogoFlexColor from '../../../../icon/logo-flex-color.svg';
import MpxIconLogoGopay from '../../../../icon/logo-gopay.svg';
import MpxIconLogoIndosat from '../../../../icon/logo-indosat.svg';
import MpxIconLogoJurnal from '../../../../icon/logo-jurnal.svg';
import MpxIconLogoJurnalColor from '../../../../icon/logo-jurnal-color.svg';
import MpxIconLogoKlikpajak from '../../../../icon/logo-klikpajak.svg';
import MpxIconLogoKlikpajakColor from '../../../../icon/logo-klikpajak-color.svg';
import MpxIconLogoMekari from '../../../../icon/logo-mekari.svg';
import MpxIconLogoMekariColor from '../../../../icon/logo-mekari-color.svg';
import MpxIconLogoOvo from '../../../../icon/logo-ovo.svg';
import MpxIconLogoPln from '../../../../icon/logo-pln.svg';
import MpxIconLogoPlnToken from '../../../../icon/logo-pln-token.svg';
import MpxIconLogoShopeepay from '../../../../icon/logo-shopeepay.svg';
import MpxIconLogoSmartfren from '../../../../icon/logo-smartfren.svg';
import MpxIconLogoTalenta from '../../../../icon/logo-talenta.svg';
import MpxIconLogoTalentaColor from '../../../../icon/logo-talenta-color.svg';
import MpxIconLogoTelkomsel from '../../../../icon/logo-telkomsel.svg';
import MpxIconLogoTri from '../../../../icon/logo-tri.svg';
import MpxIconLogoXl from '../../../../icon/logo-xl.svg';
import MpxIconMaternity from '../../../../icon/maternity.svg';
import MpxIconMeatball from '../../../../icon/meatball.svg';
import MpxIconMeatballSmall from '../../../../icon/meatball-small.svg';
import MpxIconMessage from '../../../../icon/message.svg';
import MpxIconMigrate from '../../../../icon/migrate.svg';
import MpxIconMobile from '../../../../icon/mobile.svg';
import MpxIconMobilePostpaid from '../../../../icon/mobile-postpaid.svg';
import MpxIconOutPatient from '../../../../icon/out-patient.svg';
import MpxIconPhone from '../../../../icon/phone.svg';
import MpxIconPlans from '../../../../icon/plans.svg';
import MpxIconPlayVideo from '../../../../icon/play-video.svg';
import MpxIconProducts from '../../../../icon/products.svg';
import MpxIconProgress from '../../../../icon/progress.svg';
import MpxIconPromotion from '../../../../icon/promotion.svg';
import MpxIconPromotionSmall from '../../../../icon/promotion-small.svg';
import MpxIconRefresh from '../../../../icon/refresh.svg';
import MpxIconReports from '../../../../icon/reports.svg';
import MpxIconReset from '../../../../icon/reset.svg';
import MpxIconResetSmall from '../../../../icon/reset-small.svg';
import MpxIconRemove from '../../../../icon/remove.svg';
import MpxIconRemoveOutline from '../../../../icon/remove-outline.svg';
import MpxIconSearch from '../../../../icon/search.svg';
import MpxIconSearchSmall from '../../../../icon/search-small.svg';
import MpxIconSettings from '../../../../icon/settings.svg';
import MpxIconSales from '../../../../icon/sales.svg';
import MpxIconSecurity from '../../../../icon/security.svg';
import MpxIconShare from '../../../../icon/share.svg';
import MpxIconShortcut from '../../../../icon/shortcut.svg';
import MpxIconShow from '../../../../icon/show.svg';
import MpxIconShowSmall from '../../../../icon/show-small.svg';
import MpxIconSignIn from '../../../../icon/sign-in.svg';
import MpxIconSignOut from '../../../../icon/sign-out.svg';
import MpxIconSliders from '../../../../icon/sliders.svg';
import MpxIconStockAvailable from '../../../../icon/stock-available.svg';
import MpxIconStockBulkUpdate from '../../../../icon/stock-bulk-update.svg';
import MpxIconStockRunningOut from '../../../../icon/stock-running-out.svg';
import MpxIconStockUnavailable from '../../../../icon/stock-unavailable.svg';
import MpxIconSuccess from '../../../../icon/success.svg';
import MpxIconTableField from '../../../../icon/table-field.svg';
import MpxIconTableFilter from '../../../../icon/table-filter.svg';
import MpxIconTableSort from '../../../../icon/table-sort.svg';
import MpxIconTask from '../../../../icon/task.svg';
import MpxIconTeamGoal from '../../../../icon/team-goal.svg';
import MpxIconTime from '../../../../icon/time.svg';
import MpxIconTips from '../../../../icon/tips.svg';
import MpxIconToday from '../../../../icon/today.svg';
import MpxIconTrash from '../../../../icon/trash.svg';
import MpxIconTrashSmall from '../../../../icon/trash-small.svg';
import MpxIconUpload from '../../../../icon/upload.svg';
import MpxIconUserResponse from '../../../../icon/user-response.svg';
import MpxIconUserResponseDuoTone from '../../../../icon/user-response-duotone.svg';
import MpxIconVoucher from '../../../../icon/voucher.svg';
import MpxIconVision from '../../../../icon/vision.svg';
import MpxIconWarehouse from '../../../../icon/warehouse.svg';
import MpxIconWarning from '../../../../icon/warning.svg';
import MpxIconWifi from '../../../../icon/wifi.svg';

export default {
  components: {
    MpxIconAccount,
    MpxIconAccountMapping,
    MpxIconAdd,
    MpxIconAddOutline,
    MpxIconAddOns,
    MpxIconApplyAll,
    MpxIconApprovalRules,
    MpxIconArrowLeft,
    MpxIconArrowRight,
    MpxIconAssets,
    MpxIconBilling,
    MpxIconBriefcase,
    MpxIconBroadcast,
    MpxIconBuy,
    MpxIconCalculator,
    MpxIconCalendar,
    MpxIconCalendarSmall,
    MpxIconCamera,
    MpxIconCameraSmall,
    MpxIconCaretDown,
    MpxIconCaretRight,
    MpxIconCashAndBank,
    MpxIconCertificate,
    MpxIconChannel,
    MpxIconCheck,
    MpxIconChartOfAccount,
    MpxIconChevronDown,
    MpxIconChevronForward,
    MpxIconChevronLeft,
    MpxIconChevronLeftSmall,
    MpxIconChevronPrevious,
    MpxIconChevronRight,
    MpxIconChevronRightSmall,
    MpxIconChevronUp,
    MpxIconClose,
    MpxIconCloseSmall,
    MpxIconCollapse,
    MpxIconColumnSettings,
    MpxIconCompany,
    MpxIconContact,
    MpxIconDashboard,
    MpxIconDental,
    MpxIconDownload,
    MpxIconEdit,
    MpxIconEditSmall,
    MpxIconEducation,
    MpxIconEmpty,
    MpxIconEnvelope,
    MpxIconError,
    MpxIconExpand,
    MpxIconExpenses,
    MpxIconExternalLink,
    MpxIconFamily,
    MpxIconFileBlank,
    MpxIconFileCopy,
    MpxIconFileDoc,
    MpxIconFileImg,
    MpxIconFilePdf,
    MpxIconFileText,
    MpxIconFileZip,
    MpxIconFilter,
    MpxIconFinance,
    MpxIconFlag,
    MpxIconHelp,
    MpxIconHelpCenter,
    MpxIconHide,
    MpxIconHideSmall,
    MpxIconHistory,
    MpxIconHome,
    MpxIconInbox,
    MpxIconIndividualGoal,
    MpxIconInPatient,
    MpxIconIndicator,
    MpxIconInfo,
    MpxIconInfoSmall,
    MpxIconKebab,
    MpxIconKebabSmall,
    MpxIconKeyDuotone,
    MpxIconKeyFill,
    MpxIconKeyOutline,
    MpxIconLoader,
    MpxIconLoan,
    MpxIconLogoAxis,
    MpxIconLogoChat,
    MpxIconLogoChatColor,
    MpxIconLogoFlex,
    MpxIconLogoFlexColor,
    MpxIconLogoGopay,
    MpxIconLogoIndosat,
    MpxIconLogoJurnal,
    MpxIconLogoJurnalColor,
    MpxIconLogoKlikpajak,
    MpxIconLogoKlikpajakColor,
    MpxIconLogoMekari,
    MpxIconLogoMekariColor,
    MpxIconLogoOvo,
    MpxIconLogoPln,
    MpxIconLogoPlnToken,
    MpxIconLogoShopeepay,
    MpxIconLogoSmartfren,
    MpxIconLogoTalenta,
    MpxIconLogoTalentaColor,
    MpxIconLogoTelkomsel,
    MpxIconLogoTri,
    MpxIconLogoXl,
    MpxIconMaternity,
    MpxIconMeatball,
    MpxIconMeatballSmall,
    MpxIconMessage,
    MpxIconMigrate,
    MpxIconMobile,
    MpxIconMobilePostpaid,
    MpxIconOutPatient,
    MpxIconPhone,
    MpxIconPlans,
    MpxIconPlayVideo,
    MpxIconProducts,
    MpxIconProgress,
    MpxIconPromotion,
    MpxIconPromotionSmall,
    MpxIconRefresh,
    MpxIconReports,
    MpxIconReset,
    MpxIconResetSmall,
    MpxIconRemove,
    MpxIconRemoveOutline,
    MpxIconSearch,
    MpxIconSearchSmall,
    MpxIconSettings,
    MpxIconSales,
    MpxIconSecurity,
    MpxIconShare,
    MpxIconShortcut,
    MpxIconShow,
    MpxIconShowSmall,
    MpxIconSignIn,
    MpxIconSignOut,
    MpxIconSliders,
    MpxIconStockAvailable,
    MpxIconStockBulkUpdate,
    MpxIconStockRunningOut,
    MpxIconStockUnavailable,
    MpxIconSuccess,
    MpxIconTableField,
    MpxIconTableFilter,
    MpxIconTableSort,
    MpxIconTask,
    MpxIconTeamGoal,
    MpxIconTime,
    MpxIconTips,
    MpxIconToday,
    MpxIconTrash,
    MpxIconTrashSmall,
    MpxIconUpload,
    MpxIconUserResponse,
    MpxIconUserResponseDuoTone,
    MpxIconVoucher,
    MpxIconVision,
    MpxIconWarehouse,
    MpxIconWarning,
    MpxIconWifi,
  },
};
